import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import moment from 'moment';

import {PressureService} from '../services/pressure-service';
import {PressureReadingModelSimple} from '../models/pressure-simple-model';
import {PressureReadHeadModel} from '../models/pressure-head-model';
import { ChartConfiguration, ChartType } from 'chart.js';

@Component({
    selector: 'app-pressure',
    templateUrl: './pressure.component.html',
    styleUrls: ['./pressure.component.css'],
    providers: [PressureService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PressureComponent implements OnInit {
  private readonly highPressureThreshold = 1013.25;

  public lineChartData: ChartConfiguration['data'] = {
    datasets: [],
    labels: []
  };

  pressureObject: PressureReadingModelSimple;
  pressureArr: PressureReadHeadModel;

  public lineChartOptions: any = {
    responsive: true,
    interaction: {
      mode: 'index',
      intersect: false
    },
    scales: {
      xAxes: [{
        ticks: {
          display: true,
          maxTicksLimit: 6
        }
      }],
      yAxes: [
        {
          name: 'Pressure',
          type: 'linear',
          position: 'right',
          display: true
        }
      ]
    },
    elements: {
      point: {
        radius: 4
      }
    },
    legend: {
      display: false
    },
    tooltip: {
      mode: 'index',
      intersect: false
    },
    crosshair: {
      line: {
        color: '#666',
        width: 1,
        dash: [5, 5]
      },
      snap: {
        enabled: true
      },
      zoom: {
        enabled: false
      }
    }
  };

  public lineChartColors: Array<any> = [
    { // grey
      backgroundColor: 'rgba(148,159,177,0.2)',
      borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    { // dark grey
      backgroundColor: 'rgba(77,83,96,0.2)',
      borderColor: 'rgba(77,83,96,1)',
      pointBackgroundColor: 'rgba(77,83,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,96,1)'
    },
    { // grey
      backgroundColor: 'rgba(148,159,177,0.2)',
      borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];

  public lineChartType : ChartType = 'line';

  // events
  public chartClicked(e: any): void {
  }

  public chartHovered(e: any): void {
  }

  constructor(
    private pressureService: PressureService,
    private route: ActivatedRoute
    ) {}

    ngOnInit() {
      this.pressureService.getLatest('8').subscribe(
        (data: PressureReadingModelSimple) => {
          this.pressureObject = data;
        },
        error => undefined
        );

        this.pressureService.getLastDay('8').subscribe(
          (data: PressureReadHeadModel) => {
            this.pressureArr = data;
            this.fixlineChartData();
          },
          error => undefined
          );
        }

        private fixlineChartData() {
          const dataArr = new Array<number>();
          const labelArr = new Array<string>();

          if (this.pressureArr != null) {
            const tempModel: Array<PressureReadingModelSimple> = this.pressureArr.sensorReadingsLst;


            for( const element of tempModel) {
              dataArr.push(element.sensorValue);
              labelArr.push(moment(element.sensorReadingDate).format('DD/MM HH:mm'));
            }

            this.lineChartData = {
              labels: labelArr,
              datasets: [
                {
                  data: dataArr as number[],
                  label: this.pressureArr['sensorDescription'],
                  fill: 'origin',
                  backgroundColor: 'rgba(148,159,177,0.2)',
                  borderColor: 'rgba(148,159,177,1)',
                  pointBackgroundColor: 'rgba(148,159,177,1)',
                  pointBorderColor: '#fff',
                  pointHoverBackgroundColor: '#fff',
                  pointHoverBorderColor: 'rgba(148,159,177,0.8)'
                }
              ]
            };

            if (dataArr.some(value => value > this.highPressureThreshold)) {
              this.lineChartData.datasets.push({
                data: dataArr.map(() => this.highPressureThreshold),
                label: 'Högtryck (1013 hPa)',
                fill: false,
                borderColor: '#e32636',
                borderDash: [7, 5],
                borderWidth: 2,
                pointRadius: 0,
                pointHoverRadius: 0,
                yAxisID: 'y'
              });
            }
          } else {
            this.lineChartData = {
              labels: [],
              datasets: []
            };
          }
        }
      }
